/* MS Parts - Zusatzartikel zum Mitbestellen (Konfiguration ueber #msp-addon data-h/label/note) */
(function(){
  if (window.__mspAddon) return; window.__mspAddon = 1;
  var H=document.getElementById('msp-addon'); if(!H) return;
  var ADDONS = [{h:H.getAttribute('data-h'),label:H.getAttribute('data-label'),note:H.getAttribute('data-note')}];
  var CSS = [
    '.mxp{--ln:#e4e4e7;--ink:#111;--mut:#6b7280;--acc:#1d4ed8;margin:16px 0 14px;font-size:14px;color:var(--ink)}',
    '.mxp .cap{display:block;font-size:11.5px;letter-spacing:.08em;text-transform:uppercase;color:var(--mut);margin:0 0 8px;font-weight:600}',
    '.mxp .ad{display:flex;align-items:center;gap:12px;border:1px solid var(--ln);border-radius:10px;padding:10px 12px;margin:0 0 8px;cursor:pointer;background:#fff;user-select:none}',
    '.mxp .ad.on{border-color:var(--acc);box-shadow:0 0 0 1px var(--acc)}',
    '.mxp .bx{width:20px;height:20px;border:1.5px solid #9ca3af;border-radius:5px;flex:0 0 20px;display:flex;align-items:center;justify-content:center;background:#fff}',
    '.mxp .ad.on .bx{background:var(--acc);border-color:var(--acc)}',
    '.mxp .ad.on .bx:after{content:"";width:6px;height:10px;border:solid #fff;border-width:0 2px 2px 0;transform:rotate(45deg) translate(-1px,-1px)}',
    '.mxp .ad img{width:46px;height:46px;object-fit:contain;border-radius:7px;flex:0 0 46px;background:#f3f4f6;margin:0!important}',
    '.mxp .ad .tx{flex:1;min-width:0;line-height:1.3}.mxp .ad .tx b{display:block;font-size:14px}.mxp .ad .tx span{display:block;font-size:12.5px;color:var(--mut)}',
    '.mxp .ad .pr{font-weight:600;white-space:nowrap;font-size:13.5px}'
  ].join('');
  function chf(c){ var n=c/100, i=Math.floor(n), r=Math.round((n-i)*100); return 'CHF '+String(i).replace(/\B(?=(\d{3})+(?!\d))/g,"'")+(r?'.'+(r<10?'0':'')+r:''); }
  function el(t,c,h){ var e=document.createElement(t); if(c)e.className=c; if(h!=null)e.innerHTML=h; return e; }
  function esc(s){ return String(s).replace(/[&<>"]/g,function(m){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[m];}); }
  function pjs(h){ return fetch('/products/'+h+'.js',{headers:{Accept:'application/json'}}).then(function(r){ if(!r.ok) throw 0; return r.json(); }); }
  function img(p,w){ var s=p.featured_image||(p.images&&p.images[0])||''; if(!s) return ''; return s+(s.indexOf('?')>-1?'&':'?')+'width='+w; }

  function start(tries){
    var host=H;
    var form=document.querySelector('form[action*="/cart/add"]');
    if(!form){ if((tries||0)<25) setTimeout(function(){start((tries||0)+1);},400); return; }
    host.style.display='none';
    var st=el('style'); st.textContent=CSS; document.head.appendChild(st);
    var btn=form.querySelector('[type="submit"],button[name="add"]');

    var box=el('div','mxp'); box.appendChild(el('span','cap','Gleich mitbestellen'));
    var picks={};
    Promise.all(ADDONS.map(function(a){ return pjs(a.h).then(function(p){ return {a:a,p:p}; }).catch(function(){ return null; }); }))
    .then(function(list){
      list.forEach(function(x){
        if(!x) return; var v=(x.p.variants||[]).filter(function(v){return v.available;})[0]; if(!v) return;
        var t=el('div','ad','<div class="bx"></div><img src="'+esc(img(x.p,120))+'" alt="" loading="lazy"><div class="tx"><b>'+esc(x.a.label)+'</b><span>'+esc(x.a.note)+'</span></div><div class="pr">+ '+chf(v.price)+'</div>');
        t.setAttribute('role','checkbox'); t.setAttribute('aria-checked','false'); t.tabIndex=0;
        t.onclick=function(){ if(picks[v.id]){ delete picks[v.id]; t.classList.remove('on'); t.setAttribute('aria-checked','false'); } else { picks[v.id]=1; t.classList.add('on'); t.setAttribute('aria-checked','true'); } };
        t.onkeydown=function(e){ if(e.key===' '||e.key==='Enter'){ e.preventDefault(); t.click(); } };
        box.appendChild(t);
      });
      if(box.querySelectorAll('.ad').length){
        if(btn&&btn.parentElement) btn.parentElement.parentElement.insertBefore(box, btn.parentElement); else form.appendChild(box);
      }
    });

    var pass=false;
    function hook(ev){
      var ids=Object.keys(picks); if(pass||!ids.length) return;
      var idf=form.querySelector('[name="id"]'); if(!idf||!idf.value||idf.value==='not-selected') return;
      var b=ev.type==='click' ? (ev.target.closest&&ev.target.closest('[type="submit"],button[name="add"],.gpo-clone-atc-button')) : null;
      if(ev.type==='click' && (!b || (b.closest('form')!==form && !b.classList.contains('gpo-clone-atc-button')))) return;
      ev.preventDefault(); ev.stopPropagation(); if(ev.stopImmediatePropagation) ev.stopImmediatePropagation();
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:ids.map(function(id){return {id:Number(id),quantity:1};})})})
      .catch(function(){}).then(function(){
        picks={}; box.querySelectorAll('.ad.on').forEach(function(t){ t.classList.remove('on'); t.setAttribute('aria-checked','false'); });
        pass=true; var target=b||btn; if(target) target.click(); else form.requestSubmit ? form.requestSubmit() : form.submit(); setTimeout(function(){ pass=false; },1500);
      });
    }
    document.addEventListener('click',hook,true);
    form.addEventListener('submit',hook,true);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){start(0);}); else start(0);
})();
